import React from 'react';
import './App.css';

function App() {
  const siteName = 'Top 4 Pics';
  document.title = siteName;
  return <div className="App">{siteName}</div>;
}

export default App;
